module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/pera-pera-3-ab40dac0abb01b49dc240e4e220e7fc0.jpg";